import { CarEnum, ClientEnum, ProductEnum } from "../types"
import { FinancialLeasing } from "./FinancialLeasing"
import { Insurance } from "./Insurance"
import { Loa } from "./Loa"
import { PreOwned } from "./PreOwned"

export type ProductPropsType = {
  key: ProductEnum
  clientTypes: ClientEnum[]
  carTypes: CarEnum[]
  component: React.FC<any>
}

const products: ProductPropsType[] = [
  {
    key: ProductEnum.FinancialLeasing,
    clientTypes: [ClientEnum.Business],
    carTypes: [CarEnum.New, CarEnum.Used],
    component: FinancialLeasing
  },
  {
    key: ProductEnum.Loa,
    clientTypes: [ClientEnum.Private],
    carTypes: [CarEnum.New, CarEnum.Used],
    component: Loa
  },
  {
    key: ProductEnum.Insurance,
    clientTypes: [ClientEnum.Business, ClientEnum.Private],
    carTypes: [CarEnum.New, CarEnum.Used],
    component: Insurance
  },
  {
    key: ProductEnum.Finance,
    clientTypes: [ClientEnum.Business, ClientEnum.Private],
    carTypes: [CarEnum.Used],
    component: PreOwned
  }
]

export const getAvailableProducts = (
  clientType: ClientEnum,
  carType: CarEnum
) => {
  return products.filter(
    p => p.clientTypes.includes(clientType) && p.carTypes.includes(carType)
  )
}
